module.exports = __webpack_public_path__ + "img/vrch-s-kapuci_81_viridian-zelena.abf00b23.png";